/* global axios */
import ApiClient from './ApiClient';

// Converter recursivamente um objeto em FormData. Arrays viram
// `key[]=v1&key[]=v2`, objetos aninhados viram `key[subkey]=value`.
// null vira string vazia; File é appended diretamente.
function objectToFormData(obj) {
  const fd = new FormData();
  const append = (key, value) => {
    if (value === undefined) return;
    if (value === null) {
      fd.append(key, '');
    } else if (value instanceof File) {
      fd.append(key, value);
    } else if (Array.isArray(value)) {
      if (value.length === 0) {
        // Rack cannot infer an empty collection from a missing multipart key.
        // The professionals controller normalizes this exact transport marker
        // back to [] without accepting ambiguous blank/null array members.
        fd.append(key, '[]');
      } else {
        value.forEach(v => append(`${key}[]`, v));
      }
    } else if (typeof value === 'object') {
      const entries = Object.entries(value);
      if (entries.length === 0) {
        // There is no native HTML form representation for an empty object.
        // Rails normalizes this exact marker back to an empty Parameters hash.
        fd.append(key, '{}');
      } else {
        entries.forEach(([k, v]) => append(`${key}[${k}]`, v));
      }
    } else {
      fd.append(key, String(value));
    }
  };
  Object.entries(obj).forEach(([k, v]) => append(k, v));
  return fd;
}

class ProfessionalsAPI extends ApiClient {
  constructor() {
    super('professionals', { accountScoped: true });
  }

  get(accountId, config) {
    return this.getForAccount(accountId, config);
  }

  availability(id, { date, serviceId, accountId } = {}) {
    return axios.get(`${this.urlForAccount(accountId)}/${id}/availability`, {
      params: { date, service_id: serviceId },
    });
  }

  // Detect File em data.avatar e usa FormData (multipart/form-data)
  // para upload de imagem; caso contrário envia JSON normal.
  // Mantém a compatibilidade com o ApiClient herdado.
  create(data, accountId) {
    const collectionUrl = this.urlForAccount(accountId);
    if (data && data.avatar instanceof File) {
      return axios.post(
        collectionUrl,
        objectToFormData({ professional: data }),
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );
    }
    return axios.post(collectionUrl, { professional: data });
  }

  update(id, data, accountId) {
    const memberUrl = `${this.urlForAccount(accountId)}/${id}`;
    if (data && data.avatar instanceof File) {
      return axios.patch(memberUrl, objectToFormData({ professional: data }), {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return axios.patch(memberUrl, { professional: data });
  }

  delete(id, accountId) {
    return axios.delete(`${this.urlForAccount(accountId)}/${id}`);
  }
}

export default new ProfessionalsAPI();
